
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9xorX", function(module, exports) {
/**
 * @generated SignedSource<<31914a34093bbb5b2f66ebea8ee8a5ce>>
 * @relayHash 265b6fe4cbfa044f1ab40096cb493b63
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f8a1ee157d04b6ef78b6a93ec05e9a843fbfaf25b1c9547bbf4a4e119edcbdf
const $b39e11274bc9ce90$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ids"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "ids"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedTemplateBodyList",
            "kind": "LinkedField",
            "name": "templateBodies",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateBody",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "representation"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CreateWithRovoTemplateButtonTemplatesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CreateWithRovoTemplateButtonTemplatesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "265b6fe4cbfa044f1ab40096cb493b63",
            "id": "3f8a1ee157d04b6ef78b6a93ec05e9a843fbfaf25b1c9547bbf4a4e119edcbdf",
            "metadata": {},
            "name": "CreateWithRovoTemplateButtonTemplatesQuery",
            "operationKind": "query",
            "text": "query CreateWithRovoTemplateButtonTemplatesQuery($spaceKey:String!,$ids:[String!]!){templateBodies(spaceKey:$spaceKey,ids:$ids){nodes{id,body{value,representation}}}}"
        }
    };
}();
$b39e11274bc9ce90$var$node.hash = "fb2c221974b3d859a17bc8058bcf89d8";
var $b39e11274bc9ce90$export$2e2bcd8739ae039 = $b39e11274bc9ce90$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $h7YX1 = parcelRequire("h7YX1");


var $inPa6 = parcelRequire("inPa6");


var $2Nwuj = parcelRequire("2Nwuj");


var $83Z6R = parcelRequire("83Z6R");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $8Igpw = parcelRequire("8Igpw");

const $cf423cbabe6f0423$export$e0e844c00aabd6e7 = async (cloudId)=>{
    const data = await (0, $8Igpw.performHttpFetch)({
        path: `/gateway/api/ex/confluence/${cloudId}/wiki/rest/internals/latest/smart-create/staged`,
        options: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'page'
            })
        }
    });
    return {
        contentId: String(data.id),
        type: data.type
    };
};






var $kyKWe = parcelRequire("kyKWe");








var $3vCSA = parcelRequire("3vCSA");


var $h26dv = parcelRequire("h26dv");


var $bPHr8 = parcelRequire("bPHr8");

var $i1Nyn = parcelRequire("i1Nyn");

var $jEzab = parcelRequire("jEzab");

var $2O3ot = parcelRequire("2O3ot");


var $aouqA = parcelRequire("aouqA");


var $jyA9t = parcelRequire("jyA9t");

const $728b462d4207cbbf$var$i18n = (0, $aXWIB.defineMessages)({
    createFromTemplate: {
        id: "smart-create.open-modal-with-template.create-from-template",
        defaultMessage: "Create from template: {templateName}"
    },
    templateSelectedHeading: {
        id: "smart-create.open-modal-with-template.template-selected-heading",
        defaultMessage: "Here's the template you selected. Let's start editing together."
    },
    templateSelectedDescription: {
        id: "smart-create.open-modal-with-template.template-selected-description",
        defaultMessage: "Ask for recommended next steps or tell me exactly how you would like the template filled out."
    },
    recentWork: {
        id: "smart-create.open-modal-with-template.recent-work",
        defaultMessage: "Fill this template using recent work"
    },
    recommendation: {
        id: "smart-create.open-modal-with-template.recommendation",
        defaultMessage: "What do you recommend doing?"
    }
});
/**
 * Opens the Create with Rovo smart creation modal pre-loaded with template content.
 *
 * Bypasses the normal generation step by creating a real backend conversation
 * via createConversationChannel with a pre-seeded CONFLUENCE_AIFC_PAGE_CREATE_KEY
 * action carrying the template ADF. The caller must create a staged draft first and pass its contentId.
 */ const $728b462d4207cbbf$var$useOpenModalWithTemplateImpl = ({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setTarget: setTarget } = (0, $i1Nyn.useChatContextStoreActions)();
    const { setStagingAreaMode: setStagingAreaMode, resetStagingArea: resetStagingArea, setMessageIdSelectedForPreview: setMessageIdSelectedForPreview } = (0, $2O3ot.useStagingAreaActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { seedConversation: seedConversation, processConversationMessages: processConversationMessages } = (0, $aouqA.useSmartCreationChatStoreApi)();
    const { setMessages: setMessages } = (0, $jEzab.useChatMessagesActions)();
    return (0, $42omo.useCallback)(async ({ contentId: contentId, adfBody: adfBody, templateName: templateName, spaceKey: spaceKey, onOpenCallback: onOpenCallback })=>{
        const invocationId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        // Build the action payload to be included in the agent message.
        const action = {
            key: (0, $3vCSA.CONFLUENCE_AIFC_PAGE_CREATE_KEY),
            invocation_id: invocationId,
            planned_data: {
                title: templateName,
                adf: adfBody,
                contentId: contentId,
                type: 'page'
            },
            status: 'FINISHED',
            display_name: formatMessage($728b462d4207cbbf$var$i18n.createFromTemplate, {
                templateName: templateName
            })
        };
        // Build the dialogue (human + agent messages) to seed the conversation.
        const dialogue = {
            human_message: {
                content: ''
            },
            agent_message: {
                content: [
                    `## ${formatMessage($728b462d4207cbbf$var$i18n.templateSelectedHeading)}`,
                    formatMessage($728b462d4207cbbf$var$i18n.templateSelectedDescription)
                ].join('\n\n'),
                mimeType: 'text/markdown',
                actions: [
                    action
                ]
            }
        };
        // Create backend conversation with the seeded action
        const channel = await assistanceService.createConversationChannel({
            dialogues: [
                dialogue
            ]
        });
        const conversationId = channel.id;
        // Register the staged draft as the staging-area target
        setTarget('staging-area', {
            id: contentId,
            type: 'page',
            canProvideContext: true
        });
        // Register the conversation using seedConversation (a plain setState action).
        // createConversationOptimistically/createSeededConversation use createSafeAction
        // which requires ChatStoreContainer's containerProps — unavailable here since
        // the template gallery and GlobalComponents are siblings of RightPanel.
        // skipNextFetch: true prevents ChatStoreContainer from re-fetching the conversation
        // on mount, which would overwrite the locally-seeded messages including follow-ups.
        seedConversation({
            conversationId: conversationId,
            skipNextFetch: true
        });
        // Fetch and transform messages into the store format.
        const chat = await assistanceService.getChat(conversationId);
        const storeMessages = processConversationMessages({
            latestMessages: chat ?? [],
            conversationId: conversationId,
            sendAnalyticsEvent: (payload)=>createAnalyticsEvent(payload).fire()
        });
        if (storeMessages.length > 0) {
            // Required so useSelectedPreview knows which message drives the finalize popup.
            const assistantMsg = storeMessages.find((0, $bPHr8.isStoreAssistant));
            const assistantMsgId = assistantMsg?.content?.message?.message?.id;
            // Append synthetic follow-up prompts directly. Since seedConversation was called
            // with skipNextFetch: true, ChatStoreContainer will not re-fetch and overwrite these.
            const followUpItem = {
                type: 'FOLLOW_UP',
                content: {
                    type: 'FOLLOW_UP_QUERIES',
                    message: {
                        follow_ups: [
                            {
                                type: 'SYNTHETIC',
                                text: formatMessage($728b462d4207cbbf$var$i18n.recentWork)
                            },
                            {
                                type: 'SYNTHETIC',
                                text: formatMessage($728b462d4207cbbf$var$i18n.recommendation)
                            }
                        ]
                    },
                    millisOffset: 0
                },
                id: Date.now()
            };
            setMessages(conversationId, [
                ...storeMessages,
                followUpItem
            ]);
            if (assistantMsgId) setMessageIdSelectedForPreview(assistantMsgId);
        }
        // Mark as template flow so follow-up prompts target the existing staged draft.
        setStagingAreaMode('modal', 'template-smartCreate');
        openModal({
            entryPoint: 'template-smartCreate',
            spaceKey: spaceKey,
            stagingAreaActive: true,
            content: {
                id: contentId,
                type: 'page'
            },
            // Prevents re-open loops — handleClose doesn't call resetStagingArea by default.
            onCloseCallback: resetStagingArea,
            onOpenCallback: onOpenCallback
        });
    }, [
        assistanceService,
        createAnalyticsEvent,
        formatMessage,
        openModal,
        processConversationMessages,
        resetStagingArea,
        seedConversation,
        setMessageIdSelectedForPreview,
        setMessages,
        setStagingAreaMode,
        setTarget
    ]);
};
const $728b462d4207cbbf$export$8a73e0e690bd440f = (0, $h26dv.createHookWithAssistanceService)($728b462d4207cbbf$var$useOpenModalWithTemplateImpl);


const $611bb0e525d18283$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    createWithRovoButton: {
        id: "smart-create.create-with-rovo-template-button",
        defaultMessage: "Create with Rovo"
    },
    errorTitle: {
        id: "smart-create.create-with-rovo-template-button.error-title",
        defaultMessage: "Something went wrong"
    },
    errorDescription: {
        id: "smart-create.create-with-rovo-template-button.error-description",
        defaultMessage: "<link>Refresh</link> this page and try again."
    }
});
const $611bb0e525d18283$var$CreateWithRovoTemplateButtonTemplatesQuery = (0, $b39e11274bc9ce90$export$2e2bcd8739ae039);
const $611bb0e525d18283$export$9fea881b62f7886 = new Map();
const $611bb0e525d18283$var$getTemplateIdForQuery = (template)=>{
    return template.contentBlueprintId || template.templateId || template.itemModuleCompleteKey;
};
const $611bb0e525d18283$var$CreateWithRovoTemplateButtonInner = ({ template: template, spaceKey: spaceKey, onModalOpen: onModalOpen, entryPoint: entryPoint, flags: flags })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const fetchTemplateBodies = (0, $83Z6R.useLazyQueryPromiseInterop)($611bb0e525d18283$var$CreateWithRovoTemplateButtonTemplatesQuery);
    const openModalWithTemplate = (0, $728b462d4207cbbf$export$8a73e0e690bd440f)({
        assistanceServiceParams: {
            product: 'confluence',
            experienceId: 'ai-mate',
            touchpointSource: 'template-gallery-smart-create',
            siteId: cloudId ?? ''
        }
    });
    const fetchTemplateAdf = (0, $42omo.useCallback)(async ()=>{
        const templateId = $611bb0e525d18283$var$getTemplateIdForQuery(template);
        const cacheKey = `${spaceKey}:${templateId}`;
        const cachedTemplateBody = $611bb0e525d18283$export$9fea881b62f7886.get(cacheKey);
        if (cachedTemplateBody !== undefined) return cachedTemplateBody;
        const templateBodiesData = await fetchTemplateBodies({
            variables: {
                spaceKey: spaceKey,
                ids: [
                    templateId
                ]
            }
        });
        const templateNode = templateBodiesData?.templateBodies?.nodes?.find((node)=>node?.id === templateId);
        const { value: adfBody, representation: representation } = templateNode?.body ?? {};
        if (!adfBody || representation !== 'atlas_doc_format') return undefined;
        $611bb0e525d18283$export$9fea881b62f7886.set(cacheKey, adfBody);
        return adfBody;
    }, [
        fetchTemplateBodies,
        spaceKey,
        template
    ]);
    const handleFailure = (0, $42omo.useCallback)((reason, errorMessage)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'createWithRovoTemplateButton',
                source: entryPoint === 'gallery' ? 'templateGallery' : 'templateRightRail',
                attributes: {
                    templateId: template.templateId,
                    spaceKey: spaceKey,
                    entryPoint: entryPoint,
                    reason: reason,
                    ...errorMessage && {
                        errorMessage: errorMessage
                    }
                }
            }
        }).fire();
        flags.showErrorFlag({
            title: intl.formatMessage($611bb0e525d18283$export$a7357cdd1f0b0168.errorTitle),
            description: intl.formatMessage($611bb0e525d18283$export$a7357cdd1f0b0168.errorDescription, {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: window.location.href,
                        onClick: ()=>window.location.reload()
                    }, chunks)
            })
        });
        setIsLoading(false);
    }, [
        createAnalyticsEvent,
        entryPoint,
        template.templateId,
        spaceKey,
        flags,
        intl
    ]);
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        setIsLoading(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createWithRovoTemplateButton',
                source: entryPoint === 'gallery' ? 'templateGallery' : 'templateRightRail',
                attributes: {
                    templateId: template.templateId,
                    spaceKey: spaceKey,
                    entryPoint: entryPoint
                }
            }
        }).fire();
        try {
            if (!cloudId) {
                handleFailure('missingCloudId');
                return;
            }
            const stagedResponse = await (0, $cf423cbabe6f0423$export$e0e844c00aabd6e7)(cloudId);
            const contentId = stagedResponse.contentId;
            if (!contentId) {
                handleFailure('missingContentId');
                return;
            }
            const adfBody = await fetchTemplateAdf();
            if (!adfBody) {
                handleFailure('missingTemplateAdf');
                return;
            }
            await openModalWithTemplate({
                contentId: contentId,
                adfBody: adfBody,
                templateName: template.name || '',
                spaceKey: spaceKey,
                onOpenCallback: ()=>{
                    onModalOpen?.();
                    setIsLoading(false);
                }
            });
        } catch (error) {
            handleFailure('unexpectedError', error instanceof Error ? error.message : undefined);
        }
    }, [
        cloudId,
        template,
        spaceKey,
        fetchTemplateAdf,
        openModalWithTemplate,
        onModalOpen,
        handleFailure,
        entryPoint,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        onClick: handleClick,
        isLoading: isLoading,
        testId: "create-with-rovo-button"
    }, intl.formatMessage($611bb0e525d18283$export$a7357cdd1f0b0168.createWithRovoButton));
};
const $611bb0e525d18283$export$176583e1455fb40e = (0, $7aRa9.withFlags)($611bb0e525d18283$var$CreateWithRovoTemplateButtonInner);
module.exports["CreateWithRovoTemplateButton"] = $611bb0e525d18283$export$176583e1455fb40e;

});


//# sourceMappingURL=PopupPreview.a24a4a72.js.map
